module.exports = __webpack_public_path__ + "media/images/icon/allow_orange-54c33854cb9c8a5240264dac4c0f16a2.png";